import { useState } from 'react'
import { GoalPeriod } from '../helpers'
import type { GoalValues } from '../types'

export function useEditGoalForm(initial?: Partial<GoalValues>) {
  const [targetValue, setTargetValue] = useState<number>(
    () => initial?.targetValue || 0
  )
  const [period, setPeriod] = useState<GoalPeriod>(
    () => initial?.period || new GoalPeriod(0)
  )

  return {
    values: {
      target: targetValue,
      period,
    },
    incrementGoal: () => setTargetValue((prev) => prev + 1),
    decrementGoal: () => setTargetValue((prev) => Math.max(0, prev - 1)),
    togglePeriod: () => {
      setPeriod((prev) => new GoalPeriod(1 - prev.intValue))
    },
  }
}
